export var ArticleTypes;
(function (ArticleTypes) {
    ArticleTypes["CGU"] = "cgu";
    ArticleTypes["CGV"] = "cgv";
    ArticleTypes["CPU"] = "cpu";
    ArticleTypes["LEGAL_NOTICE"] = "legal-notice";
    ArticleTypes["PRIVACY_POLICY"] = "privacy-policy";
    ArticleTypes["PRIVACY_POLICY_COOKIE"] = "privacy-policy-cookie";
    ArticleTypes["PROMOTIONS"] = "promotions";
})(ArticleTypes || (ArticleTypes = {}));
